import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { OnlineOrderingStore } from 'kiolyn-api';
import React from 'react';
import StoreCard from '../StoreCard/StoreCard';

const useStyles = makeStyles(() => ({
  storeGrid: {}
}));

interface StoreGridProps {
  stores: OnlineOrderingStore[];
  onOpenOrderingPage: (storeid: string) => void;
  onOpenScreensPage: (storeid: string) => void;
  onOpenKiosksPage: (storeid: string) => void;
  onOpenFFDPage: (storeid: string) => void;
}

export function StoreGrid({ stores, ...actions }: StoreGridProps) {
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.storeGrid}
      spacing={4}
      justify="center"
      alignContent="center"
    >
      {stores.map(store => (
        <Grid item key={store.id}>
          <StoreCard store={store} {...actions} />
        </Grid>
      ))}
    </Grid>
  );
}
